import project01 from "../../assets/images/hoobank.png";
import project02 from "../../assets/images/gym.png";
import project03 from "../../assets/images/iben.png";
import project04 from "../../assets/images/iby.png";
import project05 from "../../assets/images/geri.png";
import project06 from "../../assets/images/imo.png";
import project07 from "../../assets/images/crypto.png";
import project08 from "../../assets/images/api02.jpg";

export const project = [
  {
    id: 125,
    image: project01,
    name: "Bank Payment",
    description: " Bank payment with Bank Account Number and Bank Account",
    view: "https://msypay.netlify.app/",
    code: "https://github.com/dmx1254/bank_pay",
  },

  {
    id: 158,
    image: project02,
    name: "Gym",
    description: "Bank payment with Bank Account Number and Bank Account",
    view: "https://diamongym.netlify.app/",
    code: "https://github.com/dmx1254/diamon_gym",
  },
  {
    id: 265,
    image: project05,
    name: "Restaurant",
    description: " Bank payment with Bank Account Number and Bank Account",
    view: "https://mamadousy-traiteur.netlify.app/",
    code: "https://github.com/dmx1254/site-vitrine-moderne-with-react-js",
  },
  {
    id: 195,
    image: project03,
    name: "E-commerce",
    description: " Bank payment with Bank Account Number and Bank Account",
    view: "https://ibendouma.com/",
    code: "https://ibendouma.com/",
  },
  {
    id: 215,
    image: project04,
    name: "E-commerce",
    description: " Bank payment with Bank Account Number and Bank Account",
    view: "https://ibytrade.com/",
    code: "https://ibytrade.com/",
  },

  {
    id: 245,
    image: project06,
    name: "Real State",
    description: " Bank payment with Bank Account Number and Bank Account",
    view: "https://msy-realstate.vercel.app/",
    code: "https://github.com/dmx1254/msy-realstate",
  },
  {
    id: 385,
    image: project08,
    name: "API",
    description: " Bank payment with Bank Account Number and Bank Account",
    view: "https://msy-api.netlify.app/",
    code: "https://github.com/dmx1254/Amazon-Api-Scraper",
  },
  {
    id: 885,
    image: project07,
    name: "Crypto News",
    description: "Bank payment with Bank Account Number and Bank Account",
    view: "https://msy-crypto-news.netlify.app/",
    code: "https://github.com/dmx1254/crypto_news",
  },
];
